
const Mentee = () => {
  return (
    <div>Mentee</div>
  )
}

export default Mentee